var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.967 21.486c1.79.025 5.7.08 5.7-2.41 0-2.546-3.758-2.458-5.591-2.414-.205.005-.386.009-.535.009v4.811c.122 0 .265.002.426.004Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.9 14.473c1.493.024 4.75.078 4.75-2.185 0-2.315-3.131-2.232-4.66-2.192a18.06 18.06 0 0 1-.45.009v4.364c.104 0 .225.002.36.004Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.277 32.002c8.837-.155 15.875-7.443 15.72-16.278C31.843 6.888 24.555-.152 15.72.002 6.885.156-.153 7.445.003 16.282c.153 8.835 7.441 15.873 16.274 15.72ZM18.42 7.608c2.821.247 5.055 1.115 5.304 3.703.186 1.894-.607 3.031-1.874 3.676 2.086.501 3.393 1.74 3.135 4.519-.32 3.45-2.89 4.376-6.565 4.587v3.624h-2.186v-3.576c-.566 0-1.146-.004-1.745-.016v3.593h-2.183v-3.632a688.18 688.18 0 0 0-4.406-.013l.434-2.61h1.589c.618 0 .782-.445.82-.723l.001-9.836c-.084-.443-.372-.957-1.257-.957H7.9V7.614c1.479.001 2.934.024 4.405-.006v-3.59h2.185v3.52c.583-.012 1.17-.024 1.745-.024V4.018h2.185v3.59Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/bitcoin.bfccbf4e08d1857fd87a8c6642b72772.svg";
export { ForwardRef as ReactComponent };